import Vue from 'vue'

export class Common extends Vue {
    public get request(){
        return (this as any).$axios
    }
    public get commit(){
        return (this as any).$store.commit
    }

    
}